import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { NgxMaskModule } from 'ngx-mask';
import { TextMaskModule } from 'angular2-text-mask';
import { DataTableModule } from 'ng2-data-table';

import { CpfCnpjDirective } from './form-utils/cpf-cnpj.directive';
import { DataDirective } from './form-utils/data.directive';
import { ClickOutDirective } from './form-utils/clickout.directive';
import { WindowRef } from './utils/WindowRef';

import { SessionService } from './service/session/session.service';
import { UserService } from './service/user-service/user.service';
import { AuthGuardService } from './service/auth-guard/auth-guard.service';
import { WizardService } from './service/wizard/wizard.service';
import { CepService } from './service/cep/cep.service';
import { PerfilDataService } from './service/perfil/perfil.service';
import { HttpsRequestInterceptor } from './service/interceptor/interceptor.service';
import { CadastroService } from './service/cadastro/cadastro.service';
import { LoginService } from './service/login/login.service';
import { RecuperarSenhaService } from './service/recuperar-senha/recuperar-senha.service';
import { ConsultaUsuarioService } from './service/consulta-usuario/consultar.user.service';
import { CaixaPostalService } from './service/caixa-postal/caixa-postal.service';
import { RegistroAcoesService } from './service/registro-acoes/registro-acoes.service';
import { ProcuracoesService } from './service/procuracoes/procuracoes.service';
import { OutorgarProcuracaoService } from './service/procuracoes/outorgar-procuracao.service';
import { CertificadoService } from './service/certificado/certificado.service';
import { VersaoService } from './service/versao/versao.service';
import { ComunicadosService } from './service/comunicados/comunicados.service';
import { AplicacoesService } from './service/aplicacoes/aplicacoes.service';
import { ContribuinteService } from './service/contribuinte/contribuinte.service';
import { PermissoesService } from './service/permissoes/permissoes.service';
import { AlertasService } from './service/alertas/alertas.service';
import { TiposComunicadoService } from './service/tipos-comunicado/tipos-comunicado.service';
// import { MessagesService } from './service/messages/messages.service';

import { FilterPipe } from './pipes/filter.pipe';
import { CelularPipe } from './pipes/celular.pipe';
import { CpfCnpjPipe } from './pipes/cpf-cnpj.pipe';
import { CgfPipe } from './pipes/cgf.pipe';
import { SearchProcuracaoPipe } from './pipes/searchProcuracao.pipe';
import { SearchProcuracaoSituacaoPipe } from './pipes/searchProcuracaoSituacao.pipe';

import { FilterIrrestritasPipe } from './pipes/filter-app-irrestritas';
import { CervelloService } from './service/cervello/cervello.service';
import { AmbienteService } from './service/ambiente/ambiente.service';
import { ServicoComunicacaoService } from './service/servico-comunicacao/servico-comunicacao.service';
import { CboService } from './service/cbo/cbo.service';
import { ManualService } from './service/manual/manual.service';
import { FirstLetterUpperCasePipe } from './pipes/first-letter-upper-case';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    RoundProgressModule,
    NgxMaskModule,
    DataTableModule,
    TextMaskModule,
  ],
  exports: [
    FormsModule,
    NgxMaskModule,
    DataTableModule,
    ReactiveFormsModule,
    RoundProgressModule,
    CpfCnpjDirective,
    DataDirective,
    ClickOutDirective,
    FilterPipe,
    CelularPipe,
    CpfCnpjPipe,
    CgfPipe,
    SearchProcuracaoPipe,
    SearchProcuracaoSituacaoPipe,
    FilterIrrestritasPipe,
    FirstLetterUpperCasePipe,
    TextMaskModule,
  ],
  declarations: [
    CpfCnpjDirective,
    DataDirective,
    ClickOutDirective,
    FilterPipe,
    CelularPipe,
    CpfCnpjPipe,
    CgfPipe,
    SearchProcuracaoPipe,
    SearchProcuracaoSituacaoPipe,
    FilterIrrestritasPipe,
    FirstLetterUpperCasePipe
  ],
  providers: [
    WindowRef,
    UserService,
    AuthGuardService,
    WizardService,
    CepService,
    PerfilDataService,
    SessionService,
    CadastroService,
    LoginService,
    VersaoService,
    RecuperarSenhaService,
    ConsultaUsuarioService,
    CaixaPostalService,
    RegistroAcoesService,
    ProcuracoesService,
    OutorgarProcuracaoService,
    CertificadoService,
    ComunicadosService,
    ContribuinteService,
    AplicacoesService,
    PermissoesService,
    AlertasService,
    TiposComunicadoService,
    CervelloService,
    AmbienteService,
    ServicoComunicacaoService,
    CboService,
    ManualService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpsRequestInterceptor,
      multi: true,
    },
  ],
})
export class SharedModule {}
